import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { connect } from "react-redux";

import { abFetch } from "@/mk2/containers/AB/AB.actions";
import { ABState } from "@/mk2/containers/AB/AB.reducers";
import { getABVariant } from "@/mk2/containers/AB/AB.selectors";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { AppState } from "@/mk2/reducers";
import { LoadingState, isSuccess } from "@/mk2/reducers/loadingState";

interface OwnProps {
    name: string;
    default: React.ReactNode | (() => React.ReactNode);
    placeholder?: React.ReactNode | (() => React.ReactNode);
    [variant: string]: React.ReactNode | (() => React.ReactNode);
}

interface StateProps {
    variant: ABState;
}

interface DispatchProps {
    onLoad(name: string);
}

type Props = OwnProps & StateProps & DispatchProps;

class AB extends React.Component<Props> {
    public render() {
        const { variant } = this.props;

        return (
            <LoadingSwitch
                loadingState={variant.loadingState}
                onLoad={this.load}
                onRenderSuccess={this.renderSuccess}
                onRenderInit={this.renderInit}
                hasData={Boolean(variant.variant)}
            />
        );
    }

    private renderSuccess = (): React.ReactNode => {
        const { variant } = this.props;
        if (variant.loadingState === LoadingState.INIT) {
            return null;
        }

        let variantProp = "default";

        // No variant for this user
        if (isSuccess(variant.loadingState) && variant.variant) {
            variantProp = variant.variant;
        }

        return typeof this.props[variantProp] === "function"
            ? (this.props[variantProp] as () => React.ReactNode)()
            : (this.props[variantProp] as React.ReactNode);
    };

    private renderInit = (): React.ReactNode => {
        const { placeholder } = this.props;

        if (typeof placeholder === "function") {
            return (placeholder as () => React.ReactNode)();
        } else if (placeholder) {
            return placeholder;
        }

        return <FontAwesomeIcon icon={faSpinner} spin />;
    };

    private load = () => {
        const { onLoad, name } = this.props;
        onLoad(name);
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        variant: getABVariant(state, ownProps.name),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onLoad: abFetch,
};

export default connect(mapStateToProps, mapDispatchToProps)(AB);
